import { createClient } from "@sanity/client";
import imageUrlBuilder from '@sanity/image-url';
import { SanityImageSource } from "@sanity/image-url/lib/types/types";

export const client = createClient({
   projectId: '8i6djm3q', 
   dataset: "production", 
   apiVersion: "2024-03-11",
   useCdn: false, 
});

export const urlFor = (source: SanityImageSource) => {
  return imageUrlBuilder(client).image(source).url();
}

export const sanityFetch = (query: string, params?: any) => {
  return client.fetch(query, params);
}
